import { FunctionalComponentWithChildren } from '../../../../../../FCWithChildren';
import StyledText, { TextSize, TextStyle } from '../../../../../shared/StyledText/StyledText';
import { FC } from 'react';

export interface ProductBarcodeProps {
    content?: string;
}

const ProductBarcode: FunctionalComponentWithChildren<ProductBarcodeProps> = props => {
    return (
        <StyledText style={TextStyle.Body} size={TextSize.Small}>
            {props.content}
        </StyledText>
    );
};

export default ProductBarcode;
